<template>
  <div class="wrapper-invite modal-multi" v-if="invite">
    <div class="modal-invite">
      <div  class="invite-modal-head dd">
        <div class="top-window">
          <div class="block-game">
              <div class="block-game__img">
                <img v-if="typeof invite.game_logo == 'object'" :src="invite.game_logo[100]">
                <img v-else :src="invite.game_logo">
              </div>
              <div class="block-info">
                <p class="block-info__title">{{game_array.name}}</p>
                <p class="block-info__subtitle">Room: {{invite.name}}</p>
              </div>
            </div>
            <div class="bid" v-if="invite.wallet== 1">
              <img src="/dist/images/frontend/money.svg" alt="">
                <div>
                    <p style="color: #fdae02">{{invite.amount}}</p>
                    <span>{{__('Match bet')}}</span>
                </div>
            </div>
            <div class="bid" v-else>
                <img src="/dist/images/frontend/light-coin.svg" alt="">
                <div>
                    <p style="color: #96afd1">{{invite.amount}}</p>
                    <span>{{__('Match bet')}}</span>
                </div>
            </div>
        </div>
        <div>
        <div class="body-window">
            <div class="users">
                <p>{{__('List of participants')}}</p>
                <div class="block-info-game__players">
                    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.42566 2.80248C9.42566 4.17313 8.33297 5.27217 6.97024 5.27217C5.60752 5.27217 4.51483 4.17313 4.51483 2.80248C4.51483 1.4313 5.60752 0.333313 6.97024 0.333313C8.33297 0.333313 9.42566 1.4313 9.42566 2.80248ZM6.97025 9.66665C4.96873 9.66665 3.2597 9.34934 3.2597 8.08008C3.2597 6.8103 4.95776 6.48143 6.97025 6.48143C8.97178 6.48143 10.6808 6.79874 10.6808 8.06852C10.6808 9.33778 8.98275 9.66665 6.97025 9.66665ZM10.475 2.84704C10.475 3.54576 10.2665 4.19667 9.90092 4.73779C9.86332 4.79347 9.89675 4.8686 9.96308 4.88016C10.0545 4.89592 10.149 4.90485 10.2451 4.90747C11.2036 4.93269 12.0638 4.31225 12.3015 3.37817C12.6535 1.99071 11.6199 0.745095 10.3036 0.745095C10.1605 0.745095 10.0237 0.760331 9.89048 0.787649C9.8722 0.791852 9.85287 0.800258 9.84242 0.816544C9.82989 0.836507 9.83929 0.8633 9.85183 0.880637C10.2472 1.43804 10.475 2.11785 10.475 2.84704ZM12.0623 5.88232C12.7063 6.00893 13.1299 6.26741 13.3054 6.64304C13.4537 6.95142 13.4537 7.30918 13.3054 7.61704C13.0369 8.19966 12.1714 8.38668 11.8351 8.43502C11.7656 8.44552 11.7097 8.38511 11.717 8.31524C11.8889 6.70082 10.522 5.93538 10.1683 5.75939C10.1532 5.75151 10.1501 5.73943 10.1516 5.73207C10.1527 5.72682 10.1589 5.71841 10.1704 5.71684C10.9356 5.70265 11.7583 5.80772 12.0623 5.88232ZM3.75495 4.90741C3.85106 4.90478 3.94508 4.89638 4.037 4.88009C4.10334 4.86853 4.13677 4.79341 4.09916 4.73772C3.73354 4.19661 3.52513 3.54569 3.52513 2.84697C3.52513 2.11778 3.75286 1.43797 4.14826 0.880572C4.16079 0.863235 4.16967 0.836442 4.15766 0.816479C4.14721 0.800718 4.12736 0.791787 4.10961 0.787584C3.97589 0.760266 3.83904 0.745031 3.69593 0.745031C2.37969 0.745031 1.34602 1.99064 1.69858 3.3781C1.93624 4.31218 2.7965 4.93263 3.75495 4.90741ZM3.84819 5.73175C3.84976 5.73963 3.84663 5.75119 3.832 5.7596C3.47787 5.93559 2.11096 6.70103 2.28281 8.31492C2.29012 8.38532 2.23475 8.44521 2.16528 8.43523C1.82891 8.38689 0.96343 8.19987 0.694959 7.61725C0.546098 7.30887 0.546098 6.95163 0.694959 6.64324C0.870457 6.26762 1.29354 6.00914 1.93755 5.88201C2.24207 5.80793 3.06419 5.70286 3.82991 5.71704C3.8414 5.71862 3.84715 5.72703 3.84819 5.73175Z" fill="#6886AF"></path>
                    </svg>
                    <p>
                        <span>{{invite.users.length}}</span>/{{invite.max_players}}
                    </p>
                </div>
            </div>
        </div>
            <div class="user-list">
                <div v-for="(user, key) in invite.users" :key="key" class="d-flex users-block">
                    <div class="wrap-img mr-3">
                        <img v-if="user.photo && typeof user.photo == 'object'" :src="user.photo[40]"/>
                        <img v-else-if="user.photo" :src="user.photo"/>
                        <span v-else class="photo" :style="{'background': user.bg_color}">{{user.name.substr(0,1)}}</span>
                    </div>
                    <div class="block-window">
                        <p class="block-name">{{user.name}}</p>
                        <div class="v-list-item__subtitle">
                            <div class="block-raiting">
                                <img height="12px" src="/dist/images/frontend/fire.svg" alt="" class="ml-0 mr-1">
                                <span style="color: rgb(246, 164, 1);">{{user.rating_points}}</span>
                            </div>
                            <span class="location" style="color: rgb(150, 175, 209);">
                                  <img width="14" :src="user.location_img"> {{user.location}}
                            </span>
                        </div>
                    </div>


                </div>
            </div>

        </div>
<!--        <p>Action {{invite.action}}</p>-->
          <div class="multi-btn">
              <BaseButton
                      :width="100"
                      :height="40"
                      class_btn="btn-liteGrey-quest"
                      v-on:click="cancelInvite()"
              >
          <span>
<!--                        <img src="/dist/images/frontend/close.svg" alt="/" />-->
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.78408 6.00003L11.3896 1.39447C11.4806 1.28819 11.5282 1.15149 11.5228 1.01167C11.5174 0.871845 11.4594 0.739213 11.3605 0.640271C11.2616 0.54133 11.1289 0.483367 10.9891 0.477966C10.8493 0.472566 10.7126 0.520125 10.6063 0.61114L6.00074 5.2167L1.39519 0.605584C1.29058 0.500971 1.14869 0.4422 1.00074 0.4422C0.852799 0.4422 0.710913 0.500971 0.6063 0.605584C0.501687 0.710197 0.442916 0.852083 0.442916 1.00003C0.442916 1.14797 0.501687 1.28986 0.6063 1.39447L5.21741 6.00003L0.6063 10.6056C0.548144 10.6554 0.50091 10.7167 0.467564 10.7856C0.434218 10.8545 0.415479 10.9296 0.412523 11.0061C0.409568 11.0826 0.42246 11.1589 0.45039 11.2302C0.478321 11.3015 0.520686 11.3662 0.574828 11.4204C0.628969 11.4745 0.693718 11.5169 0.76501 11.5448C0.836301 11.5728 0.912597 11.5856 0.989108 11.5827C1.06562 11.5797 1.14069 11.561 1.20962 11.5277C1.27854 11.4943 1.33983 11.4471 1.38963 11.3889L6.00074 6.78336L10.6063 11.3889C10.7126 11.4799 10.8493 11.5275 10.9891 11.5221C11.1289 11.5167 11.2616 11.4587 11.3605 11.3598C11.4594 11.2608 11.5174 11.1282 11.5228 10.9884C11.5282 10.8486 11.4806 10.7119 11.3896 10.6056L6.78408 6.00003Z" fill="currentColor"/>
              </svg>

                          {{__('Leave the room')}}
          </span>
              </BaseButton>
          </div>

      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment';

export default {
  name: "InviteRoom",
  data: function () {
    return {
      // currentQ : 0,
      submitDisabled: false,
      submitDisableded: false,
      submitBun: false,
      // date_start: this.invite.timestamp + ((this.invite.time_end) ? this.invite.time_end : this.$inviteTimer),
      interval: null,
      lineTime: 0,
      inviteRoom: null,
    };
  },
  props: {
    activeClass: {
      type: String,
    },
  },
  computed: {
    auth() {
      return this.$store.state.auth.user;
    },
    invite() {
      return this.$store.state.games.invite_room;
    },
    lang() {
      return this.$store.state.language.lang;
    },

    game_array() {
        if (this.$filterArray(this.invite.game_translations, this.lang, 'lang')) {
            return this.$filterArray(this.invite.game_translations, this.lang, 'lang');
        } else {
            return this.$filterArray(this.invite.game_translations, 'en', 'lang');

        }
    },
  },
  watch: {},
    created() {
        this.inviteRoom= this.invite;

        let invite= this.invite;

        console.log('test invite');

        console.log(this.$filterIndexArray(['123','279', '125'], 2729));
        console.log(invite);
        console.log('play.'+invite.id+'_'+invite.game_id+'_'+invite.room_id);
        this.$echo.join('play.'+invite.id+'_'+invite.game_id+'_'+invite.room_id)
            .listen("GameConnectMatch", (response) => {
                response= response.data;
                console.log('GameConnectMatch');
                console.log(response);

                console.log('response');

                if(response.action== 'start') {
                    let auth= this.auth;
                    let find= this.$filterIndexArray(response['users_id'], auth.id);
                    console.log(response['users_id']);
                    console.log(auth.id);
                    console.log(find);

                    if(find >= 0) {
                        this.$store.dispatch("asyncInviteGame", []);
                        this.$store.dispatch("asyncInviteRoom", null);
                        this.$router.push({
                            name: "frame",
                            params: {
                                id: response.game_url,
                                room_id: response.room_id,
                                battle_id: response.battle_id,
                                lang: this.$store.getters.getLang
                            },
                        });
                    }
                } else {
                    this.$store.dispatch("asyncInviteRoom", response);
                }
            });
    },
    beforeDestroy() {
        let invite= this.inviteRoom;
console.log('beforeDestroy');
console.log('play.'+invite.id+'_'+invite.game_id+'_'+invite.room_id);
        this.$echo.leave('play.'+invite.id+'_'+invite.game_id+'_'+invite.room_id);
    },
  methods: {
    cancelInvite(time_off='closed') {
      let invite = this.invite;
      this.submitDisabled = true;

      const formData = {
        game_id: invite.game_id,
        time_off: time_off,
      };

      this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']("ajax/games/cancel_game", formData)
      .then((response) => {
          return response.json();
      })
      .then((response) => {
          if(this.$checkAuth(response)) {
              this.$store.dispatch("asyncInviteRoom", null);
          }
      })
      .catch((err) => {
          this.httpHandler(err);
      });
    },
    playGame() {
      let invite_game = this.invite;
      this.submitDisableded = true;

      const formData = {
        game_id: invite_game.game_id,
        match_id: invite_game.match_id,
        inviter_id: invite_game.inviter_id,
        amount: invite_game.amount,
      };
      this.$http
        .post("ajax/games/play_go", formData)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if(this.$checkAuth(response)) {
            if (response.data.success === true && response.data.room_id) {
              this.$router.push({
                name: "frame",
                params: {
                  id: invite_game.game_url,
                  room_id: response.data.room_id,
                  battle_id: response.data.battle_id,
                  lang: this.$store.getters.getLang
                },
              });
              this.$store.dispatch("asyncInviteGame", []);
              clearInterval(this.interval);
              this.submitDisableded = false;
            }
          }
        })
        .catch((err) => {
            this.httpHandler(err);
        });
    },
    updateClass() {
      this.$emit('updateActiveClass', this.invite.inviter_id);
    },
    sendBun() {
        this.submitBun = true;
        let invite_game = this.invite_game;
        let invite = this.invite;
        const response = {
            game_id: invite.game_id,
            user_id: invite.inviter_id,
        };

        this.$http.post("ajax/games/ban_user", response)
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                if(this.$checkAuth(response)) {
                    let index = this.$filterIndexObject(invite_game, invite.inviter_id, "inviter_id");

                    if (index >= 0) {
                        invite_game.splice(index, 1);
                        this.$store.dispatch("asyncInviteGame", invite_game);
                        this.$emit('updateActiveClass', 0);
                    }
                    this.submitBun = false;
                    clearInterval(this.interval);
                }
            })
            .catch((err) => {
                this.httpHandler(err);
                this.submitBun = false;
            });
    }
  },

  // beforeDestroy() {
  //   this.cancelInvite();
  //   clearInterval(this.interval);
  // },

  mounted() {
    // let timestamp= this.date_start;
    // this.interval = setInterval(() => {
    //   let momentUtc= (moment.utc().format('X'));
    //   if (timestamp >= momentUtc) {
    //       let timer = timestamp - momentUtc;
    //       this.lineTime= this.primNum(((this.$inviteTimer - timer)/(this.$inviteTimer/100)), 2);
    //   } else {
    //     clearInterval(this.interval);
    //     this.cancelInvite('timer');
    //   }
    // }, 1000);
  },
  components: {

  },
};
</script>

<style lang="scss" scoped>


.modal-invite .dt {
  cursor: pointer;
}

/*.modal-invite .dd{*/
/*  opacity:0;*/
/*  padding:0;*/
/*  height:0;*/
/*  transition-duration:0.3s;*/
/*}*/

/*.modal-invite .dd.active {*/
/*  opacity:1;*/
/*  padding: 30px 20px;*/
/*}*/


//.wrapper-invite {
//  position: fixed;
//  top: 50%;
//  left: 50%;
//  transform: translate(-50%, -50%);
//  width: 100%;
//  height: 100%;
//  display: flex;
//  align-items: center;
//  justify-content: center;
//  z-index: 1000;
//  //align-items: center;
//  //justify-content: center;
//  background-color: rgba(33, 33, 33, 0.5);
//}
.modal-invite {
  width: 500px;
  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}
/*.invite-modal-head {*/
/*  display: flex;*/
/*  justify-content: space-between;*/
/*  align-items: center;*/
/*  background: #fff;*/
/*  border-bottom: 3px solid rgba(112, 124, 151, 0.1);*/
/*  border-radius: 4px 4px 0px 0px;*/
/*  padding: 12px 20px;*/
/*  position: relative;*/

/*  p {*/
/*    font-weight: 400;*/
/*    font-size: 18px;*/
/*    line-height: 24px;*/
/*    color: #002b50;*/
/*  }*/

/*  .wrap-btn {*/
/*    display: flex;*/
/*    justify-content: space-between;*/

/*    .v-btn:not(.v-btn--round).v-size--default {*/
/*      height: 30px;*/
/*      min-width: 74px;*/
/*      padding: 0;*/
/*    }*/

/*    .btn-cab {*/
/*      margin-right: 0;*/
/*    }*/

/*    .v-btn.cancel {*/
/*      margin-right: 10px;*/
/*      background: #e5f0ff;*/
/*      border-radius: 6px;*/
/*      text-transform: inherit;*/
/*      font-weight: 400;*/
/*      font-size: 14px;*/
/*      line-height: 19px;*/
/*      letter-spacing: 0em;*/
/*      box-shadow: none;*/
/*      padding: 0;*/
/*    }*/

/*    .cancel {*/
/*      outline: none;*/
/*      &:hover {*/
/*        background-color: #cddff7;*/
/*      }*/
/*    }*/
/*  }*/
/*}*/

.invite-modal-body {
  background-color: #ffffff;
  border-radius: 0 0 4px 4px;
  padding: 0 20px 15px 20px;
  margin-top: -3px;
}
.wrap-modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
}

.block-game {
  .img {
    margin-right: 10px;
    box-shadow: 0 2px 24px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    width: 40px;
    height: 40px;

    .wrap-img {
      border-radius: 8px;
      width: 40px;
      height: 40px;

      img {
        border-radius: 8px;
        width: 40px;
        height: 40px;
      }
    }
  }


  .v-list-item {
    display: flex;
    align-items: center;

    &__title {
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #002b50;
      margin-bottom: 1px;
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__subtitle {
        font-weight: 500;
        font-size: 14px;
        line-height: 19px;
        color: #00C443!important;
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
  }
}

.block-bet {
    &__real {
        display: flex;
        align-items: center;
        /*background: rgba(253, 174, 2, 0.1);*/
        font-weight: 500;
        font-size: 14px;
        line-height: 19px;
        /*padding: 10px 18px;*/
        border-radius: 5px;

        img {
            height: 38px;
            margin: 0 10px 0 0;
        }

        p {
            margin: 0;
            font-size: 14px;
            line-height: 19px;
            color: #86A1C6;
        }

        span {
            font-size: 16px;
            line-height: 22px;
        }
    }

    &__lite {
        display: flex;
        align-items: center;
        /*background: #F3F7FE;*/
        font-weight: 500;
        font-size: 14px;
        line-height: 19px;
        /*padding: 10px 18px;*/
        border-radius: 5px;

        img {
            height: 38px;
            margin: 0 10px 0 0;
        }

        p {
            margin: 0;
            font-size: 14px;
            line-height: 19px;
            color: #86A1C6;
        }

        span {
            font-size: 16px;
            line-height: 22px;
        }
    }
}

.block-person {
  .image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-left: 10px;
    position: relative;

    .online {
      border-radius: 50%;
      width: 8px;
      height: 8px;
      position: absolute;
      right: 3px;
      bottom: 0;
      border: 1px solid #FFFFFF;
      box-sizing: border-box;
      background-color: #00C569;
    }

    .wrap-img {
      width: 40px;
      height: 40px;
      border-radius: 50%;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
    .photo {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      color: #FFFFFF;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      font-size: 18px;
      font-weight: bold;
      text-transform: uppercase;
      text-decoration: none;
    }
  }

  .v-list-item {
    &__title {
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      align-items: center;
      color: #002b50;
      margin-bottom: 2px;
      display: block;
      max-width: 145px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: right;
    }

    &__subtitle {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.01em;
      display: flex;
      align-items: center;
      justify-content: flex-end;

        span {
            display: flex;
            align-items: center;
        }

      .icon {
        height: 11px;
        margin-right: 4px;
      }
    }

    &__content {
      margin-top: 3px;
    }
  }
}

.block-params {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 100%;
    cursor: default;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid rgba(112, 124, 151, 0.1);

    &:after {
        content: '';
        display: none;
        position: absolute;
        left: 0;
        top: 9px;
        width: 100%;
        height: 1px;
        background: linear-gradient(90deg, rgba(0, 174, 255, 0) 0%, rgba(0, 174, 255, 0.6) 36.16%, rgba(0, 174, 255, 0.6) 67.61%, rgba(0, 174, 255, 0) 100.62%);
    }


    &__head {
        background: #fff;
        padding: 1px 6px 1px;
        border: 1px solid #00AEFF;
        box-sizing: border-box;
        border-radius: 4px;
        font-weight: 500;
        font-size: 10px;
        line-height: 14px;
        color: #002B50;
        text-transform: uppercase;
        margin-bottom: 10px;
        position: relative;
        z-index: 10;
        display: none;
    }

    &__body {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        .item-params {
            padding: 6px 12px;
            display: flex;
            align-items: center;
            background: rgba(0, 174, 255, 0.1);
            border-radius: 5px;
            margin: 4px;
            font-weight: 500;
            font-size: 14px;
            line-height: 19px;
            display: flex;
            align-items: center;
            color: #002B50;

            span {
                margin-right: 6px;
                text-transform: capitalize;
            }

            p {
                margin: 0;
                color: #00AEFF;
            }
        }
    }
}

.block-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .right {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    .left-mob {
        display: none;
    }
}

.wrap-line-time {
  overflow: hidden;
  margin: 0 -20px 15px;
}

.line-time {
  height: 3px;
  background: #00AEFF;
  //margin: 0 -14px;
  transition: 0.5s;
  //animation: loading  60s linear;
}
//@keyframes loading {
//  to {
//    transform: translateX(-100%);
//  }
//}



.v-application .info {
  background-color: #46bcff !important;
  border-color: #46bcff !important;
}

  @media screen and (max-width: 768px) {
    .modal-invite {
      width: 440px;
    }

    .invite-modal-head {
      padding: 12px 15px;
    }

    .invite-modal-body {
        padding: 0 15px 15px;
    }

    .wrap-line-time {
        margin: 0 -15px 15px;
    }

    .block-game {
      .v-list-item {

        &__title {
          font-size: 14px;
          line-height: 19px;
          max-width: 160px;
          text-overflow: ellipsis;
        }

          &__subtitle {
              font-size: 12px;
              line-height: 16px;
              max-width: 160px;
              text-overflow: ellipsis;
          }
      }
    }

    /*.block-bet__lite,*/
    /*.block-bet__real {*/
    /*    font-size: 12px;*/
    /*    line-height: 16px;*/
    /*    padding: 6px 12px;*/

    /*    img {*/
    /*        height: 16px;*/
    /*    }*/
    /*}*/

      .block-person {
          .v-list-item {
              &__title {
                  font-size: 12px;
                  line-height: 16px;
                  max-width: 130px;
              }

              &__subtitle {
                  font-size: 10px;
                  line-height: 14px;

                  .icon {
                      height: 10px;
                      margin-right: 3px;
                  }
              }
          }

          .image {
              margin-left: 8px;
          }
      }
  }

  @media screen and (max-width: 450px) {
      .modal-invite {
          width: 320px;
          border-radius: 4px;
      }

      .invite-modal-body {
          padding: 0 10px 10px;
          border-radius: 0 0 4px 4px;
      }

      .invite-modal-head {
          padding: 10px;
          border-radius: 4px 4px 0 0;
      }

      .wrap-btn {
          svg {
              display: none;
          }
      }

      .block-game {
          .v-list-item {
              min-height: fit-content!important;

              &__title {
                  font-size: 12px;
                  line-height: 16px;
                  max-width: 100px;
              }

              &__subtitle {
                  font-size: 9px;
                  line-height: 14px;
              }
          }

          .img {
              width: 32px;
              height: 32px;
              border-radius: 4px;
              margin-right: 6px;

              .wrap-img {
                  width: 32px;
                  height: 32px;
                  border-radius: 4px;

                  img {
                      width: 32px;
                      height: 32px;
                      border-radius: 4px;
                  }
              }
          }
      }

      /*.block-bet__lite,*/
      /*.block-bet__real {*/
      /*    flex-direction: column;*/
      /*    align-items: center;*/
      /*    padding: 6px 10px;*/
      /*    border-radius: 4px;*/
      /*    margin-right: 12px;*/

      /*    p {*/
      /*        font-size: 12px;*/
      /*        line-height: 16px;*/
      /*        width: 100%;*/
      /*        text-align: center;*/
      /*        margin-bottom: 4px;*/
      /*    }*/

      /*    img {*/
      /*        margin: 2px 4px 0 0;*/
      /*    }*/

      /*    span {*/
      /*        display: flex;*/
      /*        align-items: center;*/
      /*    }*/
      /*}*/

      .block-person {
          .v-list-item {
              min-height: fit-content;
              &__title {
                  max-width: 105px;
              }
          }

          .image {
              width: 32px;
              height: 32px;
              margin-left: 6px;

              .wrap-img {
                  width: 32px;
                  height: 32px;

                  img {
                      width: 32px;
                      height: 32px;
                  }
              }
          }
      }

      .block-params {
          margin: 12px 0 15px;
          padding-bottom: 11px;

          &__body {
              .item-params {
                  padding: 4px 10px;
                  font-size: 12px;
                  line-height: 16px;
              }
          }
      }

      .block-buttons {

          .right {
              width: calc(50% + 6px);

              div {
                  &:nth-child(1) {
                      display: none!important;
                  }

                  &:nth-child(2) {
                      width: 100%;
                  }
              }

          }
          .left {
              display: none;
          }
          .left-mob {
              display: flex;
              width: 100%;

              div {
                  width: 100%;
              }
          }
      }
  }
</style>
